import {
  Download, Filter, Save, ViewWeekOutlined 
} from '@mui/icons-material';
import { Icon } from '@mui/material';
import React, {
  useCallback, useMemo, useReducer 
} from 'react';

import FilterComponent from './filter-component';
import TableColumnModal from './table-column-modal';

interface TableControlsProps {
  columnProps: any; // TODO: type
  downloadable: boolean;
  edits: any; // TODO:
  filter: any; // TODO: Filter type
  filterable: boolean;
  handleDownload: () => void; // TODO correct type
  handleFilter: () => void;
  handleReset: () => void;
  handleSave: () => void;
  handleToggleColumn: (a: Event) => void;
  properties: any; // TODO: type
  togglable: boolean;
  updatable: boolean;
}

interface TableControlsState {
  showFilter?: boolean;
  showModal?: boolean;
}

function reducer(state: TableControlsState, payload: TableControlsState): TableControlsState {
  return {
    ...state,
    ...payload
  };
}

const TableControls = React.memo(function TableControls({
  columnProps,
  handleDownload,
  handleFilter,
  handleReset,
  handleSave,
  handleToggleColumn,
  downloadable,
  edits,
  filter,
  filterable,
  properties,
  togglable,
  updatable
}: TableControlsProps) {
  const [ state, dispatch ] = useReducer(reducer, {} satisfies TableControlsState);

  const saveDisabled = useMemo(() => !Object.keys(edits).length, [ edits ]);

  const handleShowFilter = useCallback(function handleShowFilter() {
    dispatch({ showFilter: true });
  }, []);

  const handleHideFilter = useCallback(function handleHideFilter() {
    dispatch({ showFilter: false });
  }, []);

  const handleShowModal = useCallback(function handleShowModal() {
    dispatch({ showModal: true });
  }, []);

  const handleHideModal = useCallback(function handleHideModal() {
    dispatch({ showModal: false });
  }, []);

  return (
    <div className="table-controls">
      { downloadable && (
        <div className="control" onClick={handleDownload}>
          <Download component={() => <span title="Download" />} />
        </div>
      ) }
      { filterable && (
        <div className="control" onClick={handleShowFilter}>
          <Filter component={() => <span title="Filter" />} />
        </div>
      ) }
      { togglable && (
        <div className="control" title="Show/Hide Columns" onClick={handleShowModal}>
          <ViewWeekOutlined />
        </div>
      ) }
      { updatable && (
        <>
          <div className={saveDisabled ? 'control disabled' : 'control'}>
            <Save component={() => <span title="Save" onClick={handleSave} />} />
          </div>
          <div className={saveDisabled ? 'control disabled' : 'control'}>
            <Icon className="" onClick={handleReset} title="Reset Changes">
              restart_alt
            </Icon>
          </div>
        </>
      ) }
      { state.showFilter && (
        <FilterComponent
          columnProps={columnProps}
          initFilter={filter}
          handleFilter={handleFilter}
          handleCancel={handleHideFilter}
          properties={properties}
        />
      ) }
      <TableColumnModal
        columnProps={columnProps}
        handleHideModal={handleHideModal}
        handleToggleColumn={handleToggleColumn}
        showModal={state.showModal ?? false}
      />
    </div>
  );
});

export default TableControls;
